module.exports = __webpack_public_path__ + "static/img/iron.698ecca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/league-ad-section/iron.png
// module id = nV8/
// module chunks = 35